import { evaluateFilter } from '@orbind/core'
import type { LinhaFiltravel } from './filter-fields.ts'
import type { WiSelecao } from './QuickFilterBar.tsx'

/**
 * A regra PURA do filtro escolhido (Todos / Meus / Atrasados / filtro salvo),
 * sem nada do navegador: a lista de Itens e o seletor de itens decidem igual
 * (SPEC-20261008-2157-filtro-no-seletor-de-itens), e ela é testável sozinha.
 */

export type LinhaDaSelecao = LinhaFiltravel & {
  id: string
  status: { id: string; isTerminal: boolean }
  assignee?: { id: string; name: string } | null
}

const estaAtrasado = (row: LinhaDaSelecao) =>
  row.dueAt !== null && new Date(row.dueAt) < new Date() && !row.status.isTerminal

/** A linha passa no filtro escolhido? Critérios de um filtro salvo valem juntos (E). */
export function passaNaSelecao(
  row: LinhaDaSelecao,
  selecao: WiSelecao,
  meuId: string,
  valores: (row: LinhaDaSelecao) => Record<string, unknown>,
): boolean {
  if (selecao.tipo === 'builtin') {
    if (selecao.id === 'mine') return row.assignee?.id === meuId
    if (selecao.id === 'overdue') return estaAtrasado(row)
    return true
  }
  const c = selecao.criteria
  if (c.mine && row.assignee?.id !== meuId) return false
  if (c.overdue && !estaAtrasado(row)) return false
  if (c.statusId && row.status.id !== c.statusId) return false
  if (c.typeId && row.type.id !== c.typeId) return false
  if (c.priorityId && row.priority?.id !== c.priorityId) return false
  if (c.assigneeId && row.assignee?.id !== c.assigneeId) return false
  // construtor avancado (campo/operador/valor), quando houver
  if (c.advanced && c.advanced.criteria.length > 0 && !evaluateFilter(valores(row), c.advanced)) return false
  return true
}
